module.exports = __webpack_public_path__ + "img/no-photo.24487662.webp";